import ComponentManager from '../shared/component-manager';

import Conversation from './components/conversation/conversation';
import ConversationArchiveButton from './components/conversation/conversation-archive-button';
import ConversationImageAttachment from './components/conversation/conversation-image-attachment';
import ConversationList from './components/conversation/conversation-list';
import ConversationRatingPopup from './components/conversation/conversation-rating-popup';
import ConversationSelect from './components/conversation/conversation-select';
import ConversationsSwitcher from './components/conversation/conversations-switcher';
import InternshipMentorSetDateModal from './components/interactive-message/internship-mentor-set-date-modal';
import MentorshipRatingForm from './components/mentorship-rating-form';

class ConversationComponentManager extends ComponentManager {
  initializeComponents() {
    ConversationArchiveButton.initialize('.conversationArchiveButton');
    ConversationImageAttachment.initialize('.conversation');
    ConversationRatingPopup.initialize('.conversationRatingPopup');
    ConversationSelect.initialize('.conversationList');
    ConversationsSwitcher.initialize('.conversationsSwitcher');
    MentorshipRatingForm.initialize('.conversationOtherUser');
    InternshipMentorSetDateModal.initialize('.internshipMentorSetDateModal');

    const conversationList = ConversationList.initialize(
      '.sidebarConversationsList'
    );

    Conversation.initialize('.conversation', {
      conversationList: conversationList[0],
    });
  }
}

export const initialize = () => {
  jQuery(() => {
    new ConversationComponentManager([
      Conversation,
      ConversationList,
      ConversationArchiveButton,
      ConversationImageAttachment,
      ConversationRatingPopup,
      ConversationSelect,
      ConversationsSwitcher,
      InternshipMentorSetDateModal,
      MentorshipRatingForm,
    ]);
  });
};
